module.exports = __webpack_public_path__ + "img/reputation.b083cead.png";